'use client';

import { T } from '@/i18n/LocaleProvider';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from 'next/link';
import { MONO_FONT } from '@/theme';
import {
  nicheLabel,
  brandLabel,
  rankMetric,
} from '@/libs/content/rankings-format';

const LABEL = {
  fontFamily: MONO_FONT,
  fontSize: '11px',
  letterSpacing: '0.1em',
  textTransform: 'uppercase',
  color: 'text.muted',
};

// Una industria: nombre, tamaño de la muestra y quién lidera. Toda la tarjeta es el enlace.
export default function NicheCard({ ranking, mark }) {
  return (
    <Box
      component={Link}
      href={ranking.href}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        p: 3,
        border: '1px solid #e2e5e3',
        borderRadius: '4px',
        textDecoration: 'none',
        color: 'inherit',
        bgcolor: 'background.default',
        transition: 'border-color 0.18s',
        '&:hover, &:focus-visible': { borderColor: 'primary.main' },
      }}
    >
      <Box>
        <Typography
          component="h3"
          sx={{
            fontSize: '22px',
            fontWeight: 400,
            letterSpacing: '-0.015em',
            lineHeight: 1.2,
          }}
        >
          <T>{nicheLabel(ranking)}</T>
        </Typography>
      </Box>

      <Box sx={{ borderTop: '1px solid #e2e5e3', pt: 2.5 }}>
        <Typography sx={{ ...LABEL, mb: 0.75 }}>
          <T>Lidera</T>
        </Typography>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'baseline',
            justifyContent: 'space-between',
            gap: 2,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <T>{mark}</T>
            <Typography sx={{ fontSize: '17px', fontWeight: 600 }}>
              <T>{brandLabel(ranking.top_brand)}</T>
            </Typography>
          </Box>
          <Typography
            sx={{
              fontSize: '28px',
              letterSpacing: '-0.02em',
              lineHeight: 1,
              color: 'text.accent',
            }}
          >
            <T>{ranking[rankMetric(ranking).top]}</T>%
          </Typography>
        </Box>
        <Typography sx={{ fontSize: '13px', color: 'text.muted', mt: 1 }}>
          <T>{ranking.n_brands}</T>
          <T> marcas · </T>
          <T>{ranking.n_queries}</T>
          <T> consultas · </T>
          <T>{ranking.n_captures}</T>
          <T> capturas</T>
        </Typography>
      </Box>

      <Typography
        sx={{
          ...LABEL,
          mt: 'auto',
          color: 'text.accent',
          fontWeight: 600,
          display: 'inline-flex',
          gap: 0.75,
        }}
      >
        <T>Ver ranking </T>
        <span aria-hidden="true">→</span>
      </Typography>
    </Box>
  );
}
